import React, { useRef, useState, useEffect } from "react";

const contactCards = [
  {
    title: "Email",
    image: "/photos/mail.png",
    subtitle: "akdoganhelin@gmail.com",
  },
  {
    title: "GitHub",
    image: "/photos/github.svg",
    subtitle: "github.com/helinakdogan",
    href: "https://github.com/helinakdogan",
  },
  {
    title: "LinkedIn",
    image: "/photos/linkedin.png",
    subtitle: "linkedin.com/in/helinakdogan",
    href: "https://www.linkedin.com/in/helinakdogan/",
  },
];

export default function Contact() {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 5);
    }
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener("resize", handleScroll);
    return () => window.removeEventListener("resize", handleScroll);
  }, []);

  return (
    <section id="contact" className="w-full bg-[#0d0d0d] py-16">
      {/* Header */}
      <div className="px-6 md:px-10">
        <h2 className="text-5xl md:text-6xl font-semibold tracking-tight text-white/90">
          Socials & Contact
        </h2>

        
      </div>

      {/* Apple-like rail */}
      <div className="relative mt-10">
        <button
          onClick={() => scrollRef.current?.scrollBy({ left: 320, behavior: "smooth" })}
          className={`absolute left-4 top-1/2 -translate-y-1/2 z-10 h-10 w-10 items-center justify-center rounded-full bg-[#111111]/80 text-white shadow-xl backdrop-blur-md transition-all hover:scale-110 hover:bg-white/10 active:scale-95 hidden ${canScrollLeft ? "md:flex" : ""}`}
          aria-label="Scroll left"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
        </button>
        <button
          onClick={() => scrollRef.current?.scrollBy({ left: 320, behavior: "smooth" })}
          className={`absolute right-4 top-1/2 -translate-y-1/2 z-10 h-10 w-10 items-center justify-center rounded-full bg-[#111111]/80 text-white shadow-xl backdrop-blur-md transition-all hover:scale-110 hover:bg-white/10 active:scale-95 hidden ${canScrollRight ? "md:flex" : ""}`}
          aria-label="Scroll right"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
        </button>
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className="flex gap-5 overflow-x-auto pb-6 pl-6 pr-6 md:pl-10 md:pr-10 snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {contactCards.map((c) => {
            const CardWrapper = c.href ? "a" : "div";

            return (
              <CardWrapper
                key={c.title}
                {...(c.href
                  ? {
                      href: c.href,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    }
                  : {})}
                className="snap-start shrink-0 w-[220px] sm:w-[240px]"
              >
                <div className="h-full rounded-[28px] bg-white/[0.03] px-7 py-8 transition-transform duration-300 hover:-translate-y-0.5 active:scale-[0.99]">
                  <div className="flex items-start gap-4">
                    <img
                      src={c.image}
                      alt=""
                      draggable={false}
                      className="h-11 w-11 shrink-0 object-contain"
                    />
                    <div className="min-w-0 pt-0.5">
                      <h3 className="text-lg font-semibold tracking-tight text-neutral-200">
                        {c.title}
                      </h3>
                      <div className="mt-1 text-[13px] text-neutral-500 truncate select-text">
                        {c.subtitle}
                      </div>
                    </div>
                  </div>
                </div>
              </CardWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
